import { Global } from '@emotion/react';
import { Flex, type MenuProps } from 'antd';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '@/contexts/AuthContext';
import { Path } from '@/enums';

import * as Style from './UserMenu.style';

export default function UserMenu() {
  const { profile, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate(Path.Login);
  };

  if (!profile) {
    return null;
  }

  const menuItems: MenuProps['items'] = [
    {
      key: 'user-info',
      label: (
        <Flex align="center" gap={8}>
          <span>歡迎</span>
          <span>{profile.name}</span>
        </Flex>
      ),
      disabled: true,
    },
    {
      key: 'logout',
      label: '登出',
      onClick: handleLogout,
    },
  ];

  return (
    <>
      <Global styles={Style.globalDropdownStyles} />

      <Style.UserMenuContainer>
        <Style.CustomDropdown
          menu={{ items: menuItems }}
          placement="bottomRight"
          trigger={['click', 'hover']}
          overlayClassName="user-menu-dropdown"
        >
          <Style.CustomAvatar
            size="large"
            style={{ cursor: 'pointer', backgroundColor: '#0e2a27' }}
          >
            {profile.name.charAt(0).toUpperCase()}
          </Style.CustomAvatar>
        </Style.CustomDropdown>
      </Style.UserMenuContainer>
    </>
  );
}
